import axios from "axios";

const endPoint = "/survey-monkey/impact-survey-result";

export function getItems({ commit, state }, props) {
  console.log("props", props);

  let params = {
    sortBy: props.pagination.sortBy,
    descending: props.pagination.descending,
    page: props.pagination.page,
    rowsPerPage: props.pagination.rowsPerPage,
    search: props.filter?.search,
    id: props.filter?.id,
  };

  return new Promise((resolve, reject) => {
    axios
      .get(endPoint, {
        params: params,
      })
      .then((response) => {
        let resData = response;

        let data = resData.data.data;

        this.dispatch("ImpactSurveyResults/groupBy", {
          list: data,
          keyGetter: (data) => data.order,
        })
          .then((response) => {
            console.log("groupBy_response", response);
          })
          .catch((err) => {
            console.error("err", err);
          });

        console.log("response", response);

        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function groupBy({ commit, store }, props) {
  return new Promise((resolve, reject) => {
    let list = props.list;
    let keyGetter = props.keyGetter;

    console.log("list", list);

    const map = new Map();
    list.forEach((item) => {
      item.row_span = false;
      item.total_row_span = 0;
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }

      if (collection != undefined && collection.length > 0) {
        collection[0].row_span = true;
        collection[0].total_row_span =
          collection.length > 1 ? collection.length : 1;
      }

      if (collection == undefined) {
        item.row_span = true;
        item.total_row_span = 1;
      }
    });
    resolve(map);
  });
}

export function getCustomer(data, props) {
  return new Promise((res, rej) => {
    axios
      .get(`company`, { params: props })
      .then((response) => {
        res(response.data);
      })
      .catch((err) => {
        rej(err);
      });
  });
}

export function createComment(data, props) {
  let headers = {};
  return new Promise((res, rej) => {
    axios
      .post(`events/slots/addfeedback/${props.coaching_session_id}`, props, {
        headers: headers,
      })
      .then((response) => {
        data.commit("setLastUpdated");
        res(response.data);
      })
      .catch((err) => {
        rej(err);
      });
  });
}

export function viewComment(data, props) {
  let headers = {
    token: "Bearer " + localStorage.getItem("token"),
  };
  return new Promise((res, rej) => {
    axios
      .get(
        `events/slots/getfeedbackcomments/${props.coaching_session_id}`,
        props,
        {
          headers: headers,
        }
      )
      .then((response) => {
        res(response.data);
      })
      .catch((err) => {
        rej(err);
      });
  });
}

export function fetchEventSlot({ commit, state }, props) {
  let params = {
    id: props.filter?.id,
  };

  return new Promise((res, rej) => {
    axios
      .get(`${props.endPoint}`, {
        params: params,
      })
      .then((response) => {
        res(response.data);
      })
      .catch((err) => {
        rej(err);
      });
  });
}
